import { useState, useEffect } from "react";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import ServicesSection from "@/components/ServicesSection";
import TrainerSection from "@/components/TrainerSection";
import LocationsSection from "@/components/LocationsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import BookingSection from "@/components/BookingSection";
import InstagramSection from "@/components/InstagramSection";
import CTASection from "@/components/CTASection";
import BirthdayTeaser from "@/components/BirthdayTeaser";
import GroupTrainingSection from "@/components/GroupTrainingSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import SEO from "@/components/SEO";
import SchemaMarkup from "@/components/SchemaMarkup";

export default function HomePage() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <main className={`transition-opacity duration-700 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}>
      <SEO 
        title="Personal Fußballtraining | Individuelles Fußballtraining"
        description="Persönliches Fußballtraining für Kinder, Jugendliche und Erwachsene. Individuelle Förderung, Techniktraining, Athletik und Fußballcamps für jedes Leistungsniveau."
        path="/"
      />
      <SchemaMarkup />
      <Navigation />
      <HeroSection />
      <ServicesSection />
      <TestimonialsSection />
      <InstagramSection />
      <CTASection />
      <BirthdayTeaser />
      <GroupTrainingSection />
      <BookingSection />
      <TrainerSection />
      <LocationsSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </main>
  );
}
